






























































import { Component, Vue, Ref, Watch } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import Logo from './assets/logoWhite.svg?inline';
import MenuBottom from './assets/menu.svg?inline';
import AzureAuth from './plugins/AzureAuth';
import API from './plugins/axios';
import { ActionsKeys } from './store/types';
import { InterfaceActionsKeys, InterfaceActionsPayload } from './store/types/interface';
import { SessionActionsKeys } from './store/types/session';
import AzureComponent from '@/components/Auth/AzureComponent.vue';
import TOSDialog from '@/components/TOS/TOSDialog.vue';
import TOSRefused from '@/components/TOS/TOSRefused.vue';

type styleValues = {
  minWidth?: string;
  width?: string;
  padding?: string;
};

@Component({
  components: {
    Logo,
    MenuBottom,
    AzureComponent,
    TOSDialog,
    TOSRefused,
  },
})
export default class App extends Vue {
  @Action(InterfaceActionsKeys.CHANGE_SIDEBAR_WIDTH) changeSidebarWidth!: (
    payload: InterfaceActionsPayload['CHANGE_SIDEBAR_WIDTH']
  ) => void;
  @Action(SessionActionsKeys.LEAVE_SESSION) leaveSession!: () => void;

  @Ref('navButton') navButton!: Vue;
  navigation = !this.$vuetify.breakpoint.smAndDown;
  isAuth = false;
  isMobile = false;
  hoverNavbarButton = false;
  tosRefused = false;
  tosResolved = false;

  get tosAccepted() {
    return this.$store.getters.tosAccepted;
  }

  toggleNav(open?: boolean) {
    if (this.navButton?.$el) {
      (this.navButton.$el as HTMLElement).blur();
    }
    this.navigation = typeof open === 'boolean' ? open : !this.navigation;
  }

  created() {
    this.$root.$on('toggleNav', () => {
      this.toggleNav();
      this.$nextTick(() => {
        this.updateContent();
      });
    });
    this.$root.$on('checkNavBar', this.updateContent);
    window.addEventListener('beforeunload', this.leaveSession);
  }

  @Watch('$router.fullPath')
  setAuth(path: string) {
    this.isAuth = path.startsWith('/auth');
    console.log('is Auth', this.isAuth);
    this.updateContent();
  }

  updateContent() {
    const content = (this.$refs.content as Vue)?.$el as HTMLElement;
    const nav = (this.$refs.nav as Vue)?.$el as HTMLElement;
    if (this.isAuth) {
      this.updateMobile();
      this.navigation = !this.isMobile;
    }
    this.$nextTick(() => {
      if (this.isAuth) {
        if (content && nav) {
          content.classList.add('paddingLeft');
          content.style.setProperty('--paddingLeft', `${nav.getBoundingClientRect().right}px`);
        }
      } else {
        if (content) content.classList.remove('paddingLeft');
      }

      if (nav) this.changeSidebarWidth(nav.getBoundingClientRect().right);
    });
  }

  updateMobile() {
    this.isMobile = window.innerWidth < 960;
  }

  isCanvas = false;

  async onLoggedIn() {
    try {
      const jwt = await AzureAuth.getToken();
      console.log(jwt);
      const { data } = await API.get('https://api.dev.otis-platform.tech/api/v0/auth/user/self/', {
        baseURL: '',
        headers: { Authorization: `Bearer ${jwt}` },
      });
      const { tnc_accepted } = data;
      this.$store.commit(ActionsKeys.SET_TOS_ACCEPTED, tnc_accepted);
      this.tosResolved = true;
    } catch (e) {
      console.error(e);
    }
  }

  async mounted() {
    await this.onLoggedIn();
    this.$router.afterEach(to => {
      this.setAuth(to.fullPath);
      this.isCanvas = to.name === 'Canvas';
    });
    this.setAuth(this.$router.currentRoute.fullPath);
    this.isCanvas = this.$router.currentRoute.name === 'Canvas';
    this.updateMobile();
    this.navigation = !this.isMobile;
    window.addEventListener('resize', this.updateContent, { passive: true });
    const nav = (this.$refs.nav as Vue)?.$el as HTMLElement;
    if (nav) {
      this.changeSidebarWidth(nav.getBoundingClientRect().right);
    }
  }

  beforeDestroy() {
    this.$root.$off('toggleNav', this.toggleNav);
    this.$root.$off('checkNavBar', this.updateContent);
    window.removeEventListener('resize', this.updateContent);
  }
}
